import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../../../components/configuration-select/configuration.service';
import { TxDefs } from '../../../services/Ebootis.Queries/TxDefs';

@Injectable({
	providedIn: 'root'
})
export class TxDefSelectService {

	constructor(
		private m_queryService: ConfigurationService,
		private m_txDefs: TxDefs
	) { }

	/**
	 * Liefert das Ergebnis des Queries für die Vorgangsarten 
	 * unter Beachtung der ZBS-Konfiguration zurück.
	 */
	public getTxDefs(p_configOid: string): Observable<TxDefs.Result[]> {
		return this.m_txDefs.query({ zbsConfig: p_configOid })
	}
}
